/**
 * El `TextField` de la casa: el de Polaris, con un `onKeyDown` que SÍ corre.
 *
 * 🐛 EL DE POLARIS 13 SE LO TRAGA. Su `<input>` lleva un `onKeyDown` propio (`handleKeyDown`) que sólo atiende las
 *    flechas de un campo numérico, y el que uno le pasa no se usa nunca. Compila igual, así que nadie se entera: Enter
 *    para buscar en el mapa no funcionó nunca (founder, 2-oct), y había diez campos más del panel así —el marcador del
 *    call center, el buscador de Aliclik, las etiquetas de WhatsApp, los valores de las variantes…— (3-oct).
 *
 * ⭐ SE ARREGLA ACÁ, NO EN CADA CAMPO. Con `onKeyDown`, el campo va dentro de un contenedor que escucha la tecla (el
 *    keydown del input sube hasta él) y que no ocupa lugar (`display: contents`): la grilla o la fila que lo contiene
 *    lo sigue viendo como antes. Sin `onKeyDown`, es el de Polaris tal cual. El barril (`@/lib/polaris`) y
 *    `AppTextField` exportan éste, así que los campos que ya lo usaban empiezan a andar sin tocarlos.
 */
import type { ComponentProps, KeyboardEvent } from 'react';
import { TextField as TextFieldDePolaris } from '@shopify/polaris';

type Props = Omit<ComponentProps<typeof TextFieldDePolaris>, 'onKeyDown'> & {
  onKeyDown?: (event: KeyboardEvent<HTMLElement>) => void;
};

export function CampoDeTexto({ onKeyDown, ...props }: Props) {
  if (!onKeyDown) return <TextFieldDePolaris {...props} />;
  return (
    <div onKeyDown={onKeyDown} style={{ display: 'contents' }}>
      <TextFieldDePolaris {...props} />
    </div>
  );
}
